import { DatabaseMetadata } from "@/api";

const data: (DatabaseMetadata & { serverName?: string })[] = [
  {
    id: "Analytics_Engine_102",
    name: "Analytics_Engine_102",
    serverName: "Analytics",
  },
  {
    id: "Analytics_Engine_103",
    name: "Analytics_Engine_103",
    serverName: "Analytics",
  },  
  {
    id: "Risk_Analyzer_104",
    name: "Risk_Analyzer_104",
    serverName: "Risk",
  },
  {
    id: "Insight_Generator_104",
    name: "Insight_Generator_104",
    serverName: "Insight",
  },
  {
    id: "Data_Profiler_105",
    name: "Data_Profiler_105",
    serverName: "Data",
  },
];

export default data;